<template>
  <div>
    <modal :show.sync="showCoronaModal" headerClasses="justify-content-center">
      <p>Chères clients, on a le plaisir de vous informer, que suite au mariage de notre fils, du 21 au 28 juin on sera
        fermé.</p>

      <table class="timetable text-right" v-if="schedules">
        <tr v-for="(index, weekday) in weekdays"
            :key="'weekday' + index"
        >
          <td>{{weekday}}</td>
          <template v-if="schedules[index] === undefined || schedules[index].length <= 0">
            <td></td>
            <td>Fermé</td>
          </template>
          <template v-else-if="schedules[index].length === 1">
            <td></td>
            <td>
              {{formattaOrario(schedules[index][0].start_time)}} &dash; {{formattaOrario(schedules[index][0].end_time)}}
            </td>
          </template>
          <template v-else>
            <td v-for="(schedule, schedule_index) in schedules[index]"
                :key="'schedule-' + index + '-' + schedule_index">
              {{formattaOrario(schedule.start_time)}} &dash; {{formattaOrario(schedule.end_time)}}
            </td>
          </template>
        </tr>
      </table>

      <template slot="footer">
        <div></div>
        <n-button type="primary" @click.native="showCoronaModal = false">Ok, j'ai compris</n-button>
      </template>
    </modal>

    <div class="page-header clear-filter" filter-color="black" id="home">
      <parallax class="page-header-image"
                style="background-image:url('/images/main-compressed.jpg?v=1.0')">
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <img class="n-logo d-none d-sm-inline-block" src="/images/logo-text-white-800-compressed.png" alt="O’ Sole Mio - pizzeria italienne à Liège, pizza napolitaine artisanale">
          <h2 class="title">Pizza napolitaine à Liège – Tradition italienne authentique</h2>
          <h3>Restaurant italien à Liège – Saveurs authentiques d'Italie</h3>
          <a class="btn btn-primary btn-lg btn-xl" href="https://book.osolemioliege.be">
            Réservez maintenant !
          </a>
          <div>
            <n-button type="neutral" size="lg" simple v-scroll-to="'#menu'">Notre Menu</n-button>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="section section-images">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="hero-images-container">
                <img src="images/logo-800-compressed.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="section" id="menu">
      <div class="container text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Notre menu</h2>
            <h5 class="description">Découvrez les saveurs de la cuisine italienne traditionnelle</h5>

            <div class="mt-5">
              <o-s-m-menu></o-s-m-menu>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="background-section before-filter" filter-color="black" background="pizze" id="history">
      <div class="background"></div>
      <div class="section-content">
        <div class="content content-right text-white">
          <h3>Notre histoire</h3>
          <p>
            Chez O’ Sole Mio, restaurant italien à Liège, vous pourrez savourer la vraie pizza napolitaine, des pâtes maison, et bien plus encore.
            Depuis plusieurs années, notre passion pour la cuisine italienne nous pousse à offrir des plats traditionnels préparés avec des ingrédients frais et de qualité.
          </p>
          <p>
            Que vous soyez pressés à midi ou que vous souhaitiez profiter d’un dîner convivial en famille ou entre amis, notre pizzeria à Liège vous accueille avec chaleur et authenticité.
            Nos pizzas napolitaines sont préparées selon la tradition italienne, avec une pâte travaillée à la main et des ingrédients soigneusement sélectionnés.
          </p>
          <p>
            O’ Sole Mio, c’est bien plus qu’un simple restaurant italien à Liège. C’est un lieu où se rencontrent passion culinaire, ambiance familiale et service attentionné.
            Que vous recherchiez une excellente pizza à Liège, un plat de pâtes fait maison ou une escapade gourmande aux saveurs d’Italie, vous êtes à la bonne adresse.
          </p>
        </div>
      </div>
    </div>


    <div class="section" id="contact">
      <div class="container">
        <!--<h3 class="text-center">Contactez-nous!</h3>-->
        <div class="row justify-content-md-center">
          <div class="col-md-4 col-xs-12" v-if="schedules">
            <h4>Horaires d'ouverture</h4>
            <table class="timetable w-100 w-sm-auto text-right">
              <tr v-for="(index, weekday) in weekdays"
                  :key="'weekday' + index"
              >
                <td>{{weekday}}</td>
                <template v-if="schedules[index] === undefined || schedules[index].length <= 0">
                  <td></td>
                  <td>Fermé</td>
                </template>
                <template v-else-if="schedules[index].length === 1">
                  <td></td>
                  <td>
                    {{formattaOrario(schedules[index][0].start_time)}} &dash; {{formattaOrario(schedules[index][0].end_time)}}
                  </td>
                </template>
                <template v-else>
                  <td v-for="(schedule, schedule_index) in schedules[index]"
                      :key="'schedule-' + index + '-' + schedule_index">
                    {{formattaOrario(schedule.start_time)}} &dash; {{formattaOrario(schedule.end_time)}}
                  </td>
                </template>
              </tr>
            </table>
          </div>
          <div class="col-md-4 col-xs-12">
            <h4>Notre Adresse</h4>
            <p>Boulevard de la Sauvenière 48, 4000 Liège</p>
            <h4>Télephone</h4>
            <p><a href="tel:+32465826991">+32 (0)465 82 69 91</a></p>
            <h4>Social</h4>
            <a class="social-link"
               href="https://www.facebook.com/osolemioliege/" target="_blank">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a class="social-link"
               href="https://www.instagram.com/o_solemioliege/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Parallax} from '@/components';
import NButton from "../components/Button";
import OSMMenu from "../components/OSMMenu";
import {Modal} from '@/components'
import axios from 'axios'
export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    OSMMenu,
    NButton,
    Parallax,
    Modal
  },
  data() {
    return {
      showCoronaModal: false,
      weekdays: {
        'Lundi': 1,
        'Mardi': 2,
        'Mercredi': 3,
        'Jeudi': 4,
        'Vendredi': 5,
        'Samedi': 6,
        'Dimanche': 0,
      },
      schedules: null,
    }
  },
  methods: {
    formattaOrario(orario) {
      // La regex cattura:
      // - il pattern "HH:MM" in un gruppo
      // - opzionalmente, i ":\d\d" dei secondi (non catturati)
      const pattern = /^(\d{1,2}:\d{2})(?::\d{2})?$/;
      const match = orario.match(pattern);

      if (match) {
        // match[1] contiene la parte "HH:MM"
        return match[1];
      } else {
        throw new Error("Formato orario non valido. Atteso HH:MM o HH:MM:SS");
      }
    },
    async getSchedules(){
      const response = await axios.get('https://book.osolemioliege.be/api/schedules');
      this.schedules = response.data;
    },
  },
  mounted() {
    this.getSchedules();
  }
};
</script>
<style lang="scss">
.timetable {
  tr {
    td {
      padding: 5px;
    }

    td:first-child {
      text-align: left;
      font-weight: bold;
    }
  }
}

.social-link {
  color: #000;
  font-size: 32px;
  margin-right: 15px;
}

.background-section {
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
  }

  position: relative;

  .section-content {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    z-index: 40;
    position: relative;
  }

  .background {
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
  }

  &[background="gnocchi"] {
    .background {
      background-image: url('../../public/images/backgrounds/gnocchi-1920-1080.jpg');
    }
  }

  &[background="vini"] {
    .background {
      background-image: url('../../public/images/backgrounds/tappi-1920-1080.jpg');
    }
  }

  &[background="dessert"] {
    .background {
      background-image: url('../../public/images/backgrounds/tiramisu-1920-1080.jpg');
    }
  }

  &[background="pizze"] {
    .background {
      background-image: url('../../public/images/bg-pizza-compressed.jpg');
      background-position: center;
      @media screen and (max-width: 768px) {
        background-position: left;
      }
    }
  }

  .content {
    padding: 15px;

    &.content-right {
      @media screen and (min-width: 1024px) {
        width: 50%;
      }
    }

    &.content-center {
      width: 70%;
      margin: 0 auto;
      text-align: center;
    }
  }
}

.modal .modal-header .close {
  z-index: 999999;
}

.modal .modal-dialog .modal-content {
  max-height: 95vh;
  overflow: auto;
}
.btn-xl{
  font-size: 2em !important;
  @media screen and (max-width: 500px){
    font-size: 1.4em !important;
    width: 100%;
    padding: 15px;
  }
}
</style>
